import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check2, Whatsapp } from "react-bootstrap-icons";
import language from "../../data/language";
import { currentLanguage } from "../../common/ui/notify";
import PageHero from "../../common/ui/PageHero";
import ContactStrip, { WHATSAPP_URL } from "../../common/ui/ContactStrip";
import "../../common/ui/ui.css";
import "./OurServices.css";

const OurServices = () => {
    const lang = currentLanguage();
    const services = language[lang].services;
    const home = language[lang].home_page;
    const headings = language[lang].header.our_services;

    const cards = [
        {title: home.sea_cargo, text: services.sea_description, image: "/static/service-img-01.jpg"},
        {title: home.air_cargo, text: services.air_description, image: "/static/service-img-02.jpg"},
        {title: home.yacht, text: services.yacht_description, image: "/static/service-img-03.jpg"}
    ];

    useEffect(() => {
        window.scrollTo({top: 0, behavior: "smooth"});
    }, [])

    return (
        <div className="cx-page services-page">
            <PageHero
                eyebrow={services.eyebrow}
                title={headings[0]}
                accent={headings[1]}
                subtitle={services.subtitle}
            />

            <section className="cx-section cx-section-tight">
                <div className="container">
                    <div className="services-grid">
                        {cards.map((card, index) => (
                            <article className="service-card" key={card.title}>
                                <div
                                    className="service-card-media"
                                    style={{backgroundImage: `url('${card.image}')`}}
                                >
                                    <span className="service-card-number">{index + 1}</span>
                                </div>
                                <div className="service-card-body">
                                    <h3 className="service-card-title">{card.title}</h3>
                                    <p className="service-card-text">{card.text}</p>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <section className="cx-section services-process-section">
                <div className="container">
                    <div className="cx-section-head">
                        <h2 className="cx-section-title">{services.process_title}</h2>
                    </div>
                    <ol className="services-steps">
                        {services.steps.map((step, index) => (
                            <li className="service-step" key={step.title}>
                                <span className="service-step-number">{String(index + 1).padStart(2, "0")}</span>
                                <h3 className="service-step-title">{step.title}</h3>
                                <p className="service-step-text">{step.text}</p>
                            </li>
                        ))}
                    </ol>
                </div>
            </section>

            <section className="cx-section">
                <div className="container">
                    <div className="cx-section-head">
                        <h2 className="cx-section-title">{services.extras_title}</h2>
                    </div>
                    <ul className="services-extras">
                        {services.extras.map((extra) => (
                            <li className="service-extra" key={extra}>
                                <span className="cx-check"><Check2 /></span>
                                <span>{extra}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <section className="cx-section cx-section-tight">
                <div className="container">
                    <div className="cx-cta">
                        <div>
                            <h2 className="cx-cta-title">{home.any_question}</h2>
                            <p className="cx-cta-text">{services.cta_text}</p>
                        </div>
                        <div className="cx-cta-actions">
                            <a
                                className="cx-btn cx-btn-ghost"
                                href={WHATSAPP_URL}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <Whatsapp /> WhatsApp
                            </a>
                            <Link to="/contact" className="cx-btn cx-btn-primary">
                                {services.cta_button} <ArrowUpRight />
                            </Link>
                        </div>
                    </div>

                    <div className="services-contact">
                        <ContactStrip />
                    </div>
                </div>
            </section>
        </div>
    )
}

export default OurServices
